module.exports = __webpack_public_path__ + "img/file-earmark-diff.c704bfbb.svg";